import {Button} from '@di-nxt/components';
import React, {useCallback} from 'react';
import {SceneHeader} from '../../../components';
import {t} from '../../../localization';
import {TeamMember} from '../../../services';

type Props = {
  members: TeamMember[];
  onAddPeople: () => void;
};

export const MembersHeader: React.FC<Props> = ({members, onAddPeople}) => {
  const handleAddMember = useCallback(() => onAddPeople && onAddPeople(), [
    onAddPeople,
  ]);

  return (
    <SceneHeader
      title={t('screens.members.title')}
      subtitle={t('screens.members.peoplecount', {count: members.length})}>
      <Button
        kind="Primary"
        size="Small"
        title={t('screens.members.addpeople')}
        onPress={handleAddMember}
      />
    </SceneHeader>
  );
};
